





















import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
    // Header: () => import('@/components/business/pc/header/InsHeader.vue'),
    // InsHeader: () => import('@/components/business/mobile/header/InsHeader.vue'),

    InsHeader: () => import('@/components/business/header/InsHeader.vue'),
    // Footer: () => import('@/components/business/pc/footer/InsFooter.vue'),
    // InsFooter: () => import('@/components/business/mobile/footer/InsFooter.vue'),
    InsFooter: () => import('@/components/business/footer/InsFooter.vue'),
    InsSlideMenu: () => import('@/components/business/header/InsSlideMenu.vue'),
    InsMenuLayout: () => import('@/components/business/header/InsMenuLayout.vue')
  }
})
export default class layout extends Vue {
  get isMobile () {
    return this.$store.state.isMobile;
  }
}
